// Base typeahead class
import "src/javascripts/vendor/typeahead.jquery";
import "src/javascripts/vendor/bloodhound";
import ToastCustom from "src/javascripts/components/alerts/ToastCustom";
import Spinner from "src/javascripts/components/utilities/Spinner";

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require("src/javascripts/vendor/bloodhound");

export default class {
  constructor(el) {
    this.el = el;
  }

  initializeBloodhound(api_url) {
    // Add query parameter to api url
    if (api_url.indexOf("?") !== -1) {
      api_url = api_url + "&query=%QUERY";
    } else {
      api_url = api_url + "?query=%QUERY";
    }

    // Set bloodhound to get data
    const bloodhound = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace("name"),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: api_url,
        wildcard: "%QUERY",
        transform: function (d) {
          // Support both standard format and direct array
          return d.data || d;
        },
      },
    });

    bloodhound.initialize();
    return bloodhound;
  }

  render(bloodhound, limit = 1010, minLength = 0) {
    // Define id of associated element
    let elId = $(this.el).attr("id");

    // Set min length from data attribute if present
    let minLengthAttr = $(this.el).data("min-length");
    if (typeof minLengthAttr !== "undefined") {
      minLength = minLengthAttr;
    }

    // Define templates
    let emptyTemplate =
      '<div class="empty-message">Unable to find anything</div>';

    // Check if this typeahead supports creation
    let supportsCreation = $(this.el).attr("data-supports-creation") === "true";
    let createText =
      $(this.el).attr("data-create-text") || "Click to create new";

    if (supportsCreation) {
      emptyTemplate =
        '<div class="empty-message">Search or enter new (min 3 letters)...</div>';
    }

    let newItemTemplate = (name, createText) =>
      '<div class="d-flex align-items-center">' +
      '<div class="mr-2">' +
      createText +
      " '" +
      name +
      "'</div>" +
      "</div>";

    let genericDisplayTemplate = (name, symbol) =>
      '<div><div class="d-inline-block">' + name + "</div></div>";

    let logoDisplayTemplate = (name, symbol, logo_url) =>
      '<div><div class="d-inline-block mr-3">' +
      '<img alt="logo" width="30px" src="' +
      logo_url +
      '"></div>' +
      '<div class="d-inline-block">' +
      name +
      " (" +
      symbol +
      ")</div></div>";

    let imageDisplayTemplate = (name, image_url) =>
      "<div class='d-flex align-items-center' style='height: 60px; min-height: 60px;'>" +
      '<div class="d-inline-block mr-3">' +
      '<img alt="logo" width="60px" src="' +
      image_url +
      '"></div>' +
      '<div class="d-inline-block">' +
      name +
      "</div></div>";

    let topicTemplate = (name, fa_key, keywords) =>
      '<div class="d-flex mr-2">' +
      '<div class="mr-3 mt-1" width="25px"><i class="fad fa-fw fa-' +
      fa_key +
      '"></i></div>' +
      '<div class="d-flex flex-column">' +
      '<div class="font-weight-normal">' +
      name +
      "</div>" +
      "</div>" +
      "</div>";

    // Render typeahead
    $(this.el).typeahead(
      {
        hint: true,
        highlight: true,
        minLength: minLength,
      },
      {
        name: "typeahead",
        display: "name",
        limit: limit,
        source: bloodhound.ttAdapter(),
        templates: {
          empty: emptyTemplate,
          suggestion(el) {
            if (el.name === null) {
              return emptyTemplate;
            } else if (
              el.is_new_household === "true" ||
              el.is_new_item === "true"
            ) {
              return newItemTemplate(el.name, createText);
            } else if (
              typeof el.logo_url !== "undefined" &&
              el.logo_url.length > 0
            ) {
              return logoDisplayTemplate(el.name, el.symbol, el.logo_url);
            } else if (
              typeof el.image_url !== "undefined" &&
              el.image_url.length > 0
            ) {
              return imageDisplayTemplate(el.name, el.image_url);
            } else if (
              typeof el.name_expanded !== "undefined" &&
              el.name_expanded.length > 0
            ) {
              return genericDisplayTemplate(el.name_expanded, el.symbol);
            } else {
              return genericDisplayTemplate(el.name, el.symbol);
            }
          },
        },
      },
    );

    // On selection - multiple potential actions to take
    $(this.el).bind("typeahead:select typeahead:autocomplete", function (ev, suggestion) {
      ev.preventDefault();

      // Check if suggestion is valid
      if (!suggestion) {
        return false;
      }

      // Define action to take
      let action = $("#" + elId).attr("data-action");

      if (
        action === "create_and_fill_hidden_field" &&
        (suggestion.is_new_household === "true" ||
          suggestion.is_new_item === "true")
      ) {
        // Handle creation of new items
        let val = $(this).val();
        let minLength = parseInt($(this).attr("data-min-create-length")) || 3;

        if (val.length < minLength) {
          ToastCustom({
            title: "Name too short",
            message: "Name must be at least " + minLength + " characters",
            delay: 5000,
            type: "warning",
          });
          $(this).focus();
          return false;
        }

        // Show minimal loading state on typeahead only
        let $typeahead = $(this);
        $typeahead.prop("disabled", true);
        $typeahead.val("Creating...");

        // Get creation parameters
        let createUrl = $(this).attr("data-create-url");
        let createParam = $(this).attr("data-create-param") || "name";
        let createParentParam = $(this).attr("data-create-parent-param");
        let accountUrl = $("body").attr("data-account-url");

        // Build URL and parameters
        let url = createUrl;
        if (createUrl.includes(":account_url")) {
          url = createUrl.replace(":account_url", accountUrl);
        }
        let params = {};
        let paramObject = {};
        paramObject[createParam] = val;
        params[createParentParam] = paramObject;

        $.ajax({
          type: "POST",
          dataType: "json",
          contentType: "application/x-www-form-urlencoded",
          headers: {
            Accept: "application/json",
          },
          beforeSend: function (xhr) {
            xhr.setRequestHeader(
              "X-CSRF-Token",
              $('meta[name="csrf-token"]').attr("content"),
            );
          },
          url: url,
          data: $.param(params),
          success: function (result) {
            // Restore typeahead
            $typeahead.prop("disabled", false);
            $typeahead.val(val);

            // Fill hidden field with new record ID
            let dataKey = $("#" + elId).attr("data-key") || "record_id";
            let recordId = result[dataKey] || result.household_id || result.id;
            let selector = $("#" + elId).attr("data-selector");
            $(selector).val(recordId);

            // Close typeahead dropdown
            $typeahead.typeahead('close');
            
            // Show success message
            ToastCustom({
              title: "Household created",
              message: "'" + val + "' has been created and selected",
              delay: 5000,
              type: "success",
            });
          },
          error: function (xhr) {
            // Restore typeahead
            $typeahead.prop("disabled", false);
            $typeahead.val("");

            let errorMsg = "There was a problem creating the item";
            try {
              let responseText = JSON.parse(xhr.responseText);
              if (responseText.error) {
                errorMsg = responseText.error;
              }
            } catch (e) {
              // Use default error message if JSON parsing fails
            }

            ToastCustom({
              title: "There was a problem",
              message: errorMsg,
              delay: 5000,
              type: "urgent",
            });
          },
        });

        return false;
      } else if (action === "visit_page") {
        let requestUrl = $("#" + elId).attr("data-request-url");
        let key = $("#" + elId).attr("data-key");
        let params = $("#" + elId).attr("data-params");
        if (typeof params !== "undefined") {
          params = JSON.parse(params);
          params[key] = suggestion.record_id;
        } else if (requestUrl.indexOf(":record_id") >= 0) {
          params = {};
          requestUrl = requestUrl.replace(":record_id", suggestion.record_id);
        }
        Turbo.visit(requestUrl + "?" + $.param(params));
      } else if (
        action === "fill_hidden_field" ||
        action === "create_and_fill_hidden_field"
      ) {
        let dataKey = $("#" + elId).attr("data-key");
        if (typeof dataKey !== "undefined") {
          let value = suggestion[dataKey];
          let selector = $("#" + elId).attr("data-selector");
          $(selector).val(value);
        }
      } else if (action === "send_selected_records") {
        let paramKey = $("#" + elId).attr("data-param-key");
        let paramVal = $("#" + elId).attr("data-param-val");
        let requestUrl = $("#" + elId).attr("data-request-url");
        requestUrl = requestUrl.replace(":record_id", suggestion.record_id);
        requestUrl = requestUrl.replace(":model_id", suggestion.model_id);

        let tableId = $(this).data('table-id');
        let $table = $('#' + tableId);
        let recordIdArray = $table.data('record-ids') || [];

        let params = {};
        params[paramKey] = Array.from(new Set(recordIdArray)); // to ensure unique ids in one request
        if (requestUrl.indexOf("?") === -1) {
          requestUrl = requestUrl + "?";
        } else {
          requestUrl = requestUrl + "&";
        }
        Turbo.visit(requestUrl + $.param(params));
      }

      // Remove hidden field validation if present
      let fe = $(this).closest(".form-group").find(".field_with_errors");
      if (fe.length !== 0) {
        let input = fe.find("input");
        fe.replaceWith(input);
      }
    });

    // On clearing a typeahead
    $(".clear-typeahead").click(function () {
      let fg = $(this).closest(".form-group");
      let ig = $(this).closest(".input-group");
      let t;
      let ta;
      if (fg.length !== 0) {
        t = fg.find(".twitter-typeahead input");
        ta = fg.find(".twitter-typeahead textarea");
        fg.find("input[type=\'hidden\']").val("");
        fg.find(".HiddenValidationField input").val("");
      } else {
        t = ig.find(".twitter-typeahead input");
        ta = ig.find(".twitter-typeahead textarea");
        ig.find("input[type=\'hidden\']").val("");
        ig.find(".HiddenValidationField input").val("");
      }
      if (typeof ta !== "undefined") {
        ta.typeahead("val", "");
        ta.focus();
      }
      if (typeof t !== "undefined") {
        t.typeahead("val", "");
        t.focus();
      }

      // Re-set validations
      $("form").resetClientSideValidations();
    });

    $('.clear-typeahead-input-group').click(function() {
      let ig = $(this).closest(".input-group");
      let t = ig.find('.twitter-typeahead input');
      ig.find("input[type=\'hidden\']").val("");
      t.typeahead('val', '');
      t.focus();
    });


  }
}
